"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/commons/global.ts');
const Cesium = window.Cesium;
exports.PUBLIC_FOLDER_CHECK = "public_folder_check";
// configuration for the UI state machine
exports.UiStateMachineConfig = Object.freeze({
    widgets: [
        { id: 'project_choices', },
        { id: 'scene_choices' },
        { id: 'main_tab' },
        { id: 'tools_menu' },
        { id: 'details' },
        { id: 'annotation' },
        { id: 'photos_window' },
        { id: 'layer' },
        { id: 'layer-photos' },
    ]
});
exports.AnnotationType = Object.freeze({
    // handles and ghosts
    handle: 'handle',
    addhandle: 'addhandle',
    deletehandle: 'deletehandle',
    ghostline: 'ghostline',
    ghostlineLabel: 'ghostlinelabel',
    volumepoint: 'volumepoint',
    edgeinfo: 'edgeinfo',
    // types
    poi: 'poi',
    area: 'area',
    line: 'line',
    volume: 'volume',
    multipoi: 'multiPoi',
    // else
    other: 'other'
});
exports.AnnotationStyle = Object.freeze({
    dotSize: 6,
    dotColor: Cesium.Color.RED.withAlpha(0.8),
    dotOutlineColor: Cesium.Color.YELLOW,
    dotOutlineSize: 0,
    dotNormalSize: 11,
    dotNormalColor: Cesium.Color.YELLOW,
    dotNormalOutlineColor: Cesium.Color.BLACK.withAlpha(0.7),
    dotNormalOutlineSize: 3,
    dotSelectedSize: 11,
    dotSelectedColor: Cesium.Color.RED,
    dotSelectedOutlineColor: Cesium.Color.YELLOW,
    dotSelectedOutlineSize: 3,
    locationSize: 30,
    locationColor: Cesium.Color.BLUE.withAlpha(0.8),
    locationOutlineSize: 1,
    locationOutlineColor: Cesium.Color.WHITE
});
exports.AppConstants = Object.freeze({
    STATUS_SCHEDULED: 1,
    STATUS_PROGRESS: 2,
    STATUS_FINISHED: 3,
    SCREEN_MOBILE: 768,
    DATAUM_ASSET: "datumAsset"
});
exports.Notification = Object.freeze({
    INFO: "info-dialog",
    WARN: "warning-dialog",
    ERROR: "error-dialog",
    SUCCESS: "success-dialog"
});
exports.APITypes = {
    ProcessorAPI: { NAME: "ProcessorAPI", IMPL: "lib.processors.Remote4DProcessor" },
    Datum360: { NAME: "Datum360", IMPL: "lib.processors.remote_apis.Datum360" },
    AutoDesk: { NAME: "AutoDesk", IMPL: "lib.workers.AutodeskWorker" },
    Trackonus: { NAME: "Trackonus", IMPL: "lib.processors.Remote4DProcessor" },
    Photoscan: { NAME: "Photoscan", IMPL: "Photoscan" },
    Agronomeye: { NAME: "Agronomeye", IMPL: "lib.processors.remote_apis.Agronomeye" },
    PositionPartners: { NAME: "PositionPartners", IMPL: "lib.processors.remote_apis.PositionPartners" },
    CapturingReality: { NAME: "CapturingReality", IMPL: "Photoscan" },
    SDK: { NAME: "SDK", IMPL: "SDK" }
};
class AppRoutes {
}
// AuthModule
AppRoutes.AUTH = "auth";
AppRoutes.EMAIL = "email";
AppRoutes.SIGNUP = "signup";
AppRoutes.ACTIVATE_ACC = "activate/:account/:token";
AppRoutes.ACTIVATE_ACC_GRP = "activate/:account/:groupUID/:token";
AppRoutes.ACTIVATE_NO_ACC = "activate/:token";
AppRoutes.OAUTH_PATH = "oauth";
AppRoutes.OAUTH = AppRoutes.OAUTH_PATH + "/:client";
AppRoutes.MSG = "msg/:message";
AppRoutes.AUTH_EMAIL = AppRoutes.AUTH + "/" + AppRoutes.EMAIL;
AppRoutes.AUTH_SIGNUP = AppRoutes.AUTH + "/" + AppRoutes.SIGNUP;
AppRoutes.AUTH_OAUTH = AppRoutes.AUTH + "/" + AppRoutes.OAUTH_PATH;
// Main module
AppRoutes.MAIN = "app";
AppRoutes.JOBS = "jobs";
AppRoutes.MAP = "map";
AppRoutes.EXPLORER = "explorer";
AppRoutes.PROJECTS = "projects";
AppRoutes.INSPECTOR = "inspector";
AppRoutes.PROFILE = "profile";
AppRoutes.CONTACT = "contact";
AppRoutes.ADMIN = "admin";
AppRoutes.ACCOUNT = "account";
AppRoutes.USERS = "users";
AppRoutes.APIS = "apis";
AppRoutes.INIT = "init";
AppRoutes.MAIN_EXPLORER = AppRoutes.MAIN + "/" + AppRoutes.EXPLORER;
AppRoutes.MAIN_INSPECTOR = AppRoutes.MAIN + "/" + AppRoutes.INSPECTOR;
AppRoutes.MAIN_PROFILE = AppRoutes.MAIN + "/" + AppRoutes.PROFILE;
AppRoutes.MAIN_CONTACT = AppRoutes.MAIN + "/" + AppRoutes.CONTACT;
AppRoutes.MAIN_SETTINGS = AppRoutes.MAIN + "/" + AppRoutes.ADMIN;
AppRoutes.MAIN_PROJECTS = AppRoutes.MAIN + "/" + AppRoutes.PROJECTS;
AppRoutes.ADMIN_ACCOUNT = AppRoutes.ADMIN + "/" + AppRoutes.ACCOUNT;
AppRoutes.ADMIN_USERS = AppRoutes.ADMIN + "/" + AppRoutes.USERS;
AppRoutes.ADMIN_APIS = AppRoutes.ADMIN + "/" + AppRoutes.APIS;
exports.AppRoutes = AppRoutes;
